import { render, staticRenderFns } from "./SettingsMenuItem.vue?vue&type=template&id=1926e0d6&scoped=true&"
import script from "./SettingsMenuItem.vue?vue&type=script&lang=js&"
export * from "./SettingsMenuItem.vue?vue&type=script&lang=js&"
import style0 from "./SettingsMenuItem.vue?vue&type=style&index=0&id=1926e0d6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1926e0d6",
  null
  
)

export default component.exports